export const primaryAdminNavItems = [
  { to: '/platform-health', label: 'Platform Health', icon: 'monitor_heart' },
  { to: '/verification', label: 'Verification Desk', icon: 'verified_user' },
  { to: '/organizations', label: 'Business Manager', icon: 'business_center' },
  { to: '/systems', label: 'Systems', icon: 'settings_input_component' },
  { to: '/sms-gateway', label: 'SMS Gateway', icon: 'sms' },
];

export const secondaryAdminNavItems = [
  { to: '/dashboard', label: 'Dashboard', icon: 'dashboard' },
  { to: '/command-alerts', label: 'Command Alerts', icon: 'notifications_active' },
  { to: '/notifications', label: 'Notifications', icon: 'notifications' },
  { to: '/growth', label: 'Growth Pulse', icon: 'analytics' },
  { to: '/call-analytics', label: 'Call Analytics', icon: 'speed' },
  { to: '/safety', label: 'Safety Desk', icon: 'policy' },
  { to: '/content', label: 'Broadcasts', icon: 'campaign' },
  { to: '/privacy-ops', label: 'Privacy Ops', icon: 'lock' },
  { to: '/monetization', label: 'Monetization', icon: 'payments' },
  { to: '/users', label: 'Users', icon: 'group' },
  { to: '/oauth/clients', label: 'OAuth Clients', icon: 'key' },
];

export const utilityAdminNavItems = [
  { to: '/security-ops', label: 'Security Logs', icon: 'shield' },
  { to: '/support', label: 'Support Inbox', icon: 'contact_support' },
];

export const adminNavItems = [
  ...primaryAdminNavItems,
  ...secondaryAdminNavItems,
  ...utilityAdminNavItems,
];

export function getActiveAdminItem(pathname) {
  if (pathname === '/command-alerts' || pathname.startsWith('/desk/')) {
    return adminNavItems.find((item) => item.to === '/command-alerts') || adminNavItems[0];
  }
  return (
    [...adminNavItems]
      .sort((a, b) => b.to.length - a.to.length)
      .find((item) => pathname === item.to || pathname.startsWith(`${item.to}/`)) ||
    adminNavItems[0]
  );
}
